import ColumnLayout from '../../../../main/components/column-layout';
import { JigyoDetail, processCdMap } from './jigyoDetailPage.presenter';
import { SkeletonCard } from '../shared/organisms/card/skeltonCard.presenter';
import { IContentsContentElem } from 'app-template-lib/utils';
import { TContentsContentParams } from '@/shared/t-contents-params';
import { FETCH_M_LG_CONFIG } from '@/main/queries/setting_m_lg_config.queries.type';
import setting_m_lg_configQueries from '@/main/queries/setting_m_lg_config.queries';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import pdca_t_pdcaQueries from '../../queries/pdca_t_pdca.queries';
import { FETCH_T_PDCA_ID, FETCH_T_PDCA_CURRENT } from '../../queries/pdca_t_pdca.queries.type';

/**
 * 事業詳細ページコンテナコンポーネント
 * @returns
 */
export function jigyoDetailPage({ formID, params }: IContentsContentElem<TContentsContentParams>) {
    const { lgcode, jigyoYear, jigyoID }: { lgcode: string; jigyoYear: string; jigyoID: string } = useParams();

    // LG設定データ取得
    const { data: lgConfigData } = useQuery<FETCH_M_LG_CONFIG>(setting_m_lg_configQueries.FETCH_M_LG_CONFIG, {
        variables: { lgcode },
        fetchPolicy: 'cache-first',
    });

    const createdYear = lgConfigData?.setting_m_lg_config[0]?.created_year;

    // 表示中の年度分だけを先に取得。lgConfigDataのcreated_yearが必要なため、取得できるまでskip
    const { data: currentData } = useQuery<FETCH_T_PDCA_CURRENT>(pdca_t_pdcaQueries.FETCH_T_PDCA_CURRENT, {
        variables: {
            _id: jigyoID,
            lgcode,
            jigyoYear: Number(jigyoYear),
            createdYear: Number(createdYear) - 1,
            _process_cd: processCdMap[Number(jigyoYear)],
        },
        skip: !createdYear,
        fetchPolicy: 'cache-first',
        onError: (error) => console.error(error.message),
    });

    // 他年度タブ・グラフ・成果指標用の全年度データ。currentDataの描画をブロックしないようバックグラウンドで取得
    // lgConfigDataはjigyoList側で同じクエリ・変数でキャッシュ済みのことが多く、
    // その場合はcache-firstによりここでの取得は追加の通信を伴わない
    const { data: historyData } = useQuery<FETCH_T_PDCA_ID>(pdca_t_pdcaQueries.FETCH_T_PDCA_ID, {
        variables: {
            lgcode,
            createdYear: Number(createdYear) - 1,
            jigyoYear: Number(createdYear),
            _id: jigyoID,
        },
        skip: !createdYear,
        fetchPolicy: 'cache-first',
        onError: (error) => console.error(error.message),
    });

    if (currentData && lgConfigData) {
        return (
            <ColumnLayout>
                <JigyoDetail
                    {...{
                        formID,
                        params,
                        lgcode,
                        jigyoID,
                        data: currentData,
                        historyData,
                        jigyoYear,
                        lgconfig: lgConfigData,
                    }}
                />
            </ColumnLayout>
        );
    } else {
        return (
            <ColumnLayout>
                <SkeletonCard createdYear={createdYear ? Number(createdYear) : undefined} selectedYear={jigyoYear} />
            </ColumnLayout>
        );
    }
}
